<!-- List picked options -->
<ul *ngIf="options.length" class="cart-table__options">
    <ng-container *ngFor="let option of options">
        <li *ngIf="option.valueId || option.value">
            <ng-container *ngIf="option.type !=='F'">
                <ng-container *ngIf="option.type !=='CL' && option.type !=='D'">
                    {{ option.optionName?.en }}: {{ (option.valueName?.en) ? option.valueName?.en :option.value }}
                </ng-container>
                <ng-container *ngIf="option.type ==='CL'">
                    {{ option.optionName?.en }}: <span class="option-color" [style]="'background:'+option.color"></span> {{option.value}}
                </ng-container>
                <ng-container *ngIf="option.type ==='D'">
                    {{ option.optionName?.en }}: {{option.value.date | date}} - {{(option.value.time)? option.value.time : '' }}
                </ng-container>
            </ng-container>
            <ng-container *ngIf="option.type ==='F' && _.findKey(option.value)">
                {{ option.optionName?.en }}: <a [href]="option.value[_.findKey(option.value)].url" target="_blank">
                    {{ option.value[_.findKey(option.value)].filename }} </a>
            </ng-container>
        </li>
    </ng-container>
</ul>

<!-- List picked options -->
<ul *ngIf="variant" class="cart-table__options">
         <li *ngIf="variant.type && variant.value">
          {{translateHelper?.localize(variant.type)}}: {{translateHelper?.localize(variant.value)}}
        </li>
 </ul>